import request from '@/utils/request'
import config from '@/utils/config'
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 后台获取设备服务配置信息
 *
 */
export function getDiskConfig() {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminDirectory/Config",
        method: "get",
    });
}

/**
 * 后台更新设备服务配置信息
 * @param data
 */
export function setDiskConfig(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminDirectory/Config",
        method: "post",
        data,
    });
}

/**
 * 后台分页获取指定用户文件目录以及文件集合
 * @param params
 */
export function getUserDirectoryList(params) {
    const arr = [];
    Object.entries(params).forEach((item) => {
        if (item[0] === "where") {
            item[1] = JSON.stringify(item[1]);
        }
        arr.push(`${item[0]}=${encodeURIComponent(item[1])}`);
    });
    return request({
        url: `${config.API_ADMIN}/Api/V1/AdminDirectory/List?${arr.join("&")}`,
        method: "get",
    });
}

/**
 * 根据id获取指定目录文件信息
 * @param params
 */
export function getFileInfo(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminDirectory/One",
        method: "get",
        params,
    });
}

/**
 * 后台获取用户云盘容量使用情况信息 适用于用户管理、云盘管理
 * @param params
 */
export function getUserCapacity(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminDirectory/User/Capacity",
        method: "get",
        params,
    });
}

/**
 * 后台编辑用户云盘最大用量限制   适用于用户管理、云盘管理
 * @param data
 */
export function resetUserCapacity(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminDirectory/User/Capacity",
        method: "post",
        data,
    });
}

/**
 * 分页获取在使用的云盘用户信息
 * @param params
 */
export function getUserDiskInfoList(params) {
    const arr = [];
    Object.entries(params).forEach((item) => {
        if (item[0] === "where") {
            item[1] = JSON.stringify(item[1]);
        }
        arr.push(`${item[0]}=${encodeURIComponent(item[1])}`);
    });
    return request({
        url: `${config.API_ADMIN}/Api/V1/AdminDirectory/User/List?${arr.join("&")}`,
        method: "get",
    });
}